import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MetaDataWrapper from 'modules/Common/containers/MetaDataWrapper';

import { standardAsyncConnect } from 'utils/asyncConnectWrapper';
import catchLifeCycleErrors from 'utils/catchLifeCycleErrors';
import { getStoryType } from 'utils/ArticleUtils';

import { isLoadingByEventIdStoryType, loadByEventIdStoryType, lookupRef } from 'modules/Common/reducers/article';
import { loadMediaForArticles } from 'modules/Common/reducers/media';

import Article from 'modules/News/components/Article';
import AdvertWrapper from "modules/Common/components/AdvertWrapper";

@standardAsyncConnect([
  {
    dispatch: ({state, params: { matchId }, routes}) => loadByEventIdStoryType(state, matchId, getStoryType(routes)),
    preventResolve: ({state, params: { matchId }, routes}) => isLoadingByEventIdStoryType(state, matchId, getStoryType(routes)),
    then: ({dispatch, state, result}) => loadMediaForArticles(state, dispatch, result.articles)
  }
])
@catchLifeCycleErrors
export default class FootballMatchArticle extends Component {

  static propTypes = {
    matchLabel: PropTypes.string,
    route: PropTypes.shape({
      storyType: PropTypes.string.isRequired
    }).isRequired,
    params: PropTypes.object.isRequired
  }

  render() {

    const {
      matchLabel,
      route: {
        storyType
      } = {},
      params: {
        matchId
      }
    } = this.props;

    const label = {
      MATCH_PREVIEW: "Preview",
      MATCH_REPORT: "Match Report",
      MATCH_REACTION: "Reaction"
    }[storyType];

    return (
      <div>
        <MetaDataWrapper title={`${matchLabel} - ${label}`}/>
        <Article embedded={true} embeddedLabel={label} articleIdRef={lookupRef(matchId, storyType)} />
        <AdvertWrapper ocSlot={["football", "leaderboard"]} additionalProperties={{view: "live"}} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/Football/containers/FootballMatchArticle.js